import { writable, type Readable } from "svelte/store";
import en from "../constants/copy.en";

export type RootPage = "flow" | "error" | "campaign-teaser" | "campaign-over" | "prizes" | "faq";
export type FlowStep = "home" | "register" | "code" | "thank-you";

type OnErrorRetry = (() => void) | undefined;
type ErrorSetting = keyof (ReturnType<typeof en>)["error"];

export type RouteStore = {
  isLoading: boolean;
  page: RootPage;
  step: FlowStep;
  errorSetting: ErrorSetting;
  onErrorRetry: OnErrorRetry;
};

const flowSteps: FlowStep[] = ["home", "register", "code", "thank-you"];

const initStore = () => {
  return writable<RouteStore>({
    isLoading: true,
    page: "flow",
    step: "home",
    errorSetting: "generic",
    onErrorRetry: undefined
  });
};

const internalRoute = initStore();
export const route: Readable<RouteStore> = internalRoute;

export const setPage = (page: RootPage, errorSetting: ErrorSetting = "generic", onErrorRetry?: OnErrorRetry) => {
  internalRoute.update((state) => ({
    ...state,
    page,
    errorSetting,
    onErrorRetry
  }));
};

export const setFlowStep = (step: FlowStep) => {
  internalRoute.update((state) => ({
    ...state,
    page: "flow",
    step
  }));
};

export const nextStep = () => {
  internalRoute.update((state) => ({
    ...state,
    step: flowSteps[flowSteps.indexOf(state.step) + 1]
  }));
};

export const setLoading = (loading: boolean) => {
  internalRoute.update((state) => ({
    ...state,
    isLoading: loading
  }));
};
